import { ChatDotsIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const Notes = ({ notes }) => {
  const theme = useTheme()

  if (!notes) return null
  return (
    <Styles.Container>
      <ChatDotsIcon />
      <Text type="bodyMRegular" color={theme.colors.accent.on}>
        &quot;{notes}&quot;
      </Text>
    </Styles.Container>
  )
}

export default Notes
